import { useState } from 'react'
import { Header } from './components/Header'
import { Sidebar } from './components/Sidebar'
import { Ticker } from './components/Ticker'
import { Map } from './components/Map'
import { Filters } from './components/Filters'
import { SubmitOrganizationModal, ClaimOrganizationModal, FeedbackModal, InfoModal } from './components/Modals'
import { COLORS } from './lib/constants'
import { useOrganizations } from './hooks'

const styles = {
  app: {
    minHeight: '100vh',
    display: 'flex',
    flexDirection: 'column' as const,
    backgroundColor: COLORS.parchment,
    overflowX: 'hidden' as const,
    overflowY: 'auto' as const,
  },
  main: {
    flex: 1,
    display: 'flex',
    flexDirection: 'column' as const,
    minHeight: 0,
    position: 'relative' as const,
  },
  tickerOverlay: {
    position: 'absolute' as const,
    top: 0,
    left: 0,
    right: 0,
    zIndex: 10,
  },
}

function App() {
  const {
    organizations,
    loading,
    error,
    updateSearch,
    updateServices,
    updateSector,
    updateProvince,
    clearFilters,
    resultCount,
    totalCount,
  } = useOrganizations()
  const [isSubmitModalOpen, setIsSubmitModalOpen] = useState(false)
  const [isClaimModalOpen, setIsClaimModalOpen] = useState(false)
  const [isFeedbackModalOpen, setIsFeedbackModalOpen] = useState(false)
  const [isInfoModalOpen, setIsInfoModalOpen] = useState(false)
  const [filtersVisible, setFiltersVisible] = useState(false)

  return (
    <div style={styles.app}>
      <Header />
      <main style={styles.main}>
        <div style={styles.tickerOverlay}>
          <Ticker />
        </div>
        <Sidebar
          onInfoClick={() => setIsInfoModalOpen(true)}
          onSubmitClick={() => setIsSubmitModalOpen(true)}
          onClaimClick={() => setIsClaimModalOpen(true)}
          onFeedbackClick={() => setIsFeedbackModalOpen(true)}
          onFilterToggle={() => setFiltersVisible(!filtersVisible)}
          filtersVisible={filtersVisible}
        />
        {error && <div style={{ color: 'red', padding: '20px' }}>Error loading organizations: {error.message}</div>}
        {loading && <div style={{ padding: '20px', color: COLORS.graphite }}>Loading organizations...</div>}
        <Map organizations={organizations} />
        {filtersVisible && (
          <Filters
            onSearchChange={updateSearch}
            onServiceTagsChange={updateServices}
            onSectorChange={updateSector}
            onProvinceChange={updateProvince}
            onClearFilters={clearFilters}
            resultCount={resultCount}
            totalCount={totalCount}
          />
        )}
      </main>
      <SubmitOrganizationModal
        isOpen={isSubmitModalOpen}
        onClose={() => setIsSubmitModalOpen(false)}
      />
      <ClaimOrganizationModal
        isOpen={isClaimModalOpen}
        onClose={() => setIsClaimModalOpen(false)}
      />
      <FeedbackModal
        isOpen={isFeedbackModalOpen}
        onClose={() => setIsFeedbackModalOpen(false)}
      />
      <InfoModal
        isOpen={isInfoModalOpen}
        onClose={() => setIsInfoModalOpen(false)}
      />
    </div>
  )
}

export default App
